import { slotList } from "@/Util/manifest";

export default {
  ReportAccidents: {
    plural: "Izveštaj povrede na radu",
    labelNew: "Novi izveštaj povrede na radu",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportPositions: {
    plural: "Izveštaj mesta sa povećanim rizikom",
    labelNew: "Novi izveštaj mesta sa povećanim rizikom",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportHealth: {
    plural: "Izveštaj profesionalne bolesti",
    labelNew: "Novi izveštaj profesionalne bolesti",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportHazards: {
    plural: "Izveštaj izloženosti biološkim štetnostima",
    labelNew: "Novi izveštaj izloženosti bio. štet.",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportDanger: {
    plural: "Izveštaj izloženosti karcinogenim supstancama",
    labelNew: "Novi izveštaj izloženosti karc. supst.",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "zaposleni.title",
        label: "Zaposleni",
        default: true,
        contentComponent: "DispRelated",
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportSteps: {
    plural: "Izveštaj o primeni mera za bezbednost i zdravlje na radu",
    labelNew: "Novi izveštaj o primeni mera za bezbednost i zdravlje na radu",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportSteps: {
    plural: "Izveštaj o primeni mera za bezbednost i zdravlje na radu",
    labelNew: "Novi izveštaj o primeni mera za bezbednost i zdravlje na radu",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportEquipment: {
    plural: "Izveštaj o izvršenim pregledima i proverama opreme za rad",
    labelNew: "Novi izveštaj o izvršenim pregledima i proverama opreme za rad",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportElektro: {
    plural: "Izveštaj o izvršenim pregledima i ispitivanjima električnih i grom. instalacija",
    labelNew: "Novi izveštaj o izvršenim pregledima i ispitivanjima električnih i grom. instalacija",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportEnviron: {
    plural: "Izveštaj o izvršenim pregledima i ispitivanjima uslova radne sredine",
    labelNew: "Novi izveštaj o izvršenim pregledima i ispitivanjima uslova radne sredine",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },
  ReportPPE: {
    plural: "Izveštaj o izdatoj ličnoj zaštitnoj opremi",
    labelNew: "Novi izveštaj o izdatoj ličnoj zaštitnoj opremi",
    columns: slotList([
      {
        name: "klijent.title",
        label: "Klijent",
        default: true,
      },
      {
        name: "document.filename",
        label: "Dokument",
        default: true,
      },
      {
        name: "updated",
        label: "Datum",
        searchComponent: "SearchText",
        contentComponent: "DispDate",
      },
    ]),
  },


}
